import { LANG_NAME, RUS_LANG, SECRET_KEY_ADMIN } from '../constant/constants';
import { CribDto } from '../dto/CribDto';
import { TestDto } from '../dto/TestDto';
import { AlertSeverityEnum } from '../enum/AlertSeverityEnum';
import { IAlertProps } from '../interface/IAlertProps';
import { IApiResult } from '../interface/IApiResult';

export const getAbstartcIndex = (abstarct: string) => {
  if (abstarct === '') {
    return '';
  }
  const nameAbstarct = abstarct.split('/');
  return `${nameAbstarct[nameAbstarct.length - 1]}.md`;
};

export const FormatTestJsonToText = (tests: TestDto[]) => {
  let testString = '';

  for (let i = 0; i < tests.length; i += 1) {
    let options = '';
    let author = '';
    if (tests[i].authorId === 1) {
      author = '_P';
    }
    if (tests[i].authorId === 2) {
      author = '_S';
    }
    if (tests[i].authorId === 3) {
      author = '_G';
    }
    const { type } = tests[i];
    if (type === 'latin_ending_picker') {
      testString = `${testString}${tests[i].question} [${tests[i].stem}]\n`;
    } else {
      testString = `${testString}${tests[i].question}\n`;
    }

    testString = `${testString}#${type}${author}\n`;
    if (tests[i].hint !== '') {
      testString = `${testString}##${tests[i].hint}\n`;
    }
    if (
      (type === 'text' ||
        type === 'word_part_selection' ||
        type === 'latin_ending_picker') &&
      tests[i] !== undefined &&
      tests[i].options !== undefined &&
      tests[i].correctOptions !== undefined
    ) {
      for (let j = 0; j < tests[i].options!.length; j += 1) {
        const numJ = j + 1;
        let plus = '';
        if (tests[i].correctOptions!.includes(tests[i].options![j] as string)) {
          plus = ' +';
        }
        options = `${options}${numJ}. ${tests[i].options![j]}${plus}\n`;
      }
    }

    testString = `${testString}${options}\n`;
  }
  return testString.endsWith('\n\n') ? testString.slice(0, -2) : testString;
};

export const GetCridDtoFromString = (idCrib: number, arra: string[]) => {
  const cribDto: CribDto[] = [];
  for (let i = 0; i < arra.length; i += 1) {
    cribDto.push({
      id: `${idCrib}_${i}`,
      crib: arra[i],
    });
  }
  return cribDto;
};

export const isMobileView = () => {
  const result = window.innerWidth < 820;
  return result;
};

export const getDefaultAlertProps = () => {
  const alertApp: IAlertProps = {
    message: '',
    severity: AlertSeverityEnum.error,
  };
  return alertApp;
};

export const getDefaultApiResult = () => {
  const apiResult: IApiResult = {
    isSuccess: false,
    status: -1,
    data: null,
    alert: getDefaultAlertProps(),
  };
  return apiResult;
};

export const setToken = (tokenType: string) =>
  `${localStorage.getItem(tokenType)}`;

export const getSimvol = (length: number) => {
  let result = '';
  const characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i += 1) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export const secureToken = () => {
  const expires = Math.floor(Date.now() / 1000) + 10;
  // eslint-disable-next-line global-require, @typescript-eslint/no-var-requires
  const md5 = require('md5');
  const crc = md5(`${SECRET_KEY_ADMIN}${expires}`);
  const url = `expires=${expires}&crc=${crc}`;
  return url;
};

export const getCookie = (name: string) => {
  const matches = document.cookie.match(
    new RegExp(
      `(?:^|; )${name.replace(
        /([\\.$?*|{}\\(\\)\\[\]\\\\/\\+^])/g,
        '\\$1'
      )}=([^;]*)`
    )
  );
  return matches ? decodeURIComponent(matches[1]) : undefined;
};

export const getLang = () => {
  const lang =
    localStorage.getItem(LANG_NAME) === null
      ? RUS_LANG
      : localStorage.getItem(LANG_NAME);
  return lang;
};

export const getKeyLevel = (key?: string) => {
  if (key === undefined) {
    return 0;
  }
  const arrayLevel = key.split('.');
  return arrayLevel.length;
};

export const getFontWeight = (level: number) => {
  switch (level) {
    case 1:
      return 900;
    case 2:
      return 700;
    case 3:
      return 500;
    case 4:
      return 300;
    case 5:
      return 100;
    default:
      return 100;
  }
};

export const getFontSize = (level: number) => {
  switch (level) {
    case 1:
      return '24px';
    case 2:
      return '20px';
    case 3:
      return '18px';
    case 4:
      return '16px';
    case 5:
      return '14px';
    default:
      return '14px';
  }
};

export const getPadding = (level: number) => {
  switch (level) {
    case 1:
      return '0px';
    case 2:
      return '25px';
    case 3:
      return '50px';
    case 4:
      return '75px';
    case 5:
      return '100px';
    default:
      return '0px';
  }
};

export const getSovar = (key: string) => {
  switch (key) {
    case '1.1.1':
      return 'ost_corpus';
    case '1.1.2.1':
      return 'ost_corpus';
    case '1.1.2.2':
      return 'ost_corpus';
    case '1.1.2.3':
      return 'ost_corpus';
    case '1.1.2.4':
      return 'ost_corpus';
    case '1.1.2.5':
      return 'ost_corpus';
    case '1.1.2.6':
      return 'ost_corpus';
    case '1.1.4':
      return 'ost_corpus';
    case '1.1.5':
      return 'ost_corpus';
    case '1.1.6':
      return 'ost_corpus';
    case '1.1.7':
      return 'ost_corpus';
    case '1.1.8':
      return 'ost_corpus';
    case '1.1.3':
      return 'sacrum';
    case '1.2.2':
      return 'ost_upper_limb';
    case '1.2.3':
      return 'ost_upper_limb';
    case '1.2.4':
      return 'ost_upper_limb';
    case '1.2.5':
      return 'ost_upper_limb';
    case '1.2.6':
      return 'ost_upper_limb';
    case '1.2.7':
      return 'ost_upper_limb';
    case '1.3.2':
      return 'ost_lower_limb';
    case '1.3.3':
      return 'ost_lower_limb';
    case '1.3.4':
      return 'ost_lower_limb';
    case '1.3.5':
      return 'ost_lower_limb';
    case '1.3.6':
      return 'ost_lower_limb';
    case '1.3.7':
      return 'ost_lower_limb';
    case '1.4.2.1':
      return 'ost_cranium';
    case '1.4.2.2':
      return 'ost_cranium';
    case '1.4.2.3':
      return 'ost_cranium';
    case '1.4.2.4':
      return 'ost_cranium';
    case '1.4.2.5':
      return 'ost_cranium';
    case '1.4.2.6':
      return 'ost_cranium';
    case '1.4.2.7':
      return 'ost_cranium';
    case '1.4.2.8':
      return 'ost_cranium';
    case '1.4.2.9':
      return 'ost_cranium';
    case '1.4.3.1':
      return 'ost_cranium';
    case '1.4.3.2':
      return 'ost_cranium';
    case '1.4.3.3':
      return 'ost_cranium';
    case '1.4.3.4':
      return 'ost_cranium';
    case '1.4.3.5':
      return 'ost_cranium';
    case '1.4.3.6':
      return 'ost_cranium';
    case '1.4.4.1':
      return 'ost_cranium';
    case '1.4.4.2':
      return 'ost_cranium';
    case '1.4.4.3':
      return 'ost_cranium';
    case '1.4.4.4':
      return 'ost_cranium';
    case '1.4.4.5':
      return 'ost_cranium';
    case '1.4.4.6':
      return 'ost_cranium';
    case '1.4.4.7':
      return 'ost_cranium';
    case '1.4.4.9':
      return 'ost_cranium';
    case '2.2.1':
      return 'art_columnae_vertebralis';
    case '2.2.2':
      return 'art_sacrococcygea';
    case '2.2.3.1':
      return 'art_atlantooccipitalis';
    case '2.2.3.2':
      return 'art_atlantoaxialis';
    case '2.2.4.1':
      return 'art_capitis_costae';
    case '2.2.4.2':
      return 'art_costotransversaria';
    case '2.2.4.3':
      return 'art_sternocostales';
    case '2.2.5.1':
      return 'art_temporomandibularis';
    case '2.2.6':
      return 'art_lumbosacralis';
    case '2.2.7':
      return 'art_sacroiliaca';
    case '2.3.2':
      return 'art_sternoclavicularis';
    case '2.3.3':
      return 'art_acromioclavicularis';
    case '2.3.4':
      return 'art_syndesmosis_scapulae';
    case '2.3.5':
      return 'art_humeri';
    case '2.3.6':
      return 'art_cubiti';
    case '2.3.7':
      return 'art_radioulnaris_distalis';
    case '2.3.8':
      return 'art_radiocarpalis';
    case '2.3.9':
      return 'art_manus';
    case '2.4.2':
      return 'art_symphysis_pubica';
    case '2.4.3':
      return 'art_pelvis';
    case '2.4.5':
      return 'art_coxae';
    case '2.4.6':
      return 'art_genus';
    case '2.4.7':
      return 'art_tibiofibularis';
    case '2.4.8':
      return 'art_talocruralis';
    case '2.4.9':
      return 'art_pedis';
    case '3.1':
      return 'mus_head';
    case '3.2.1':
      return 'mus_neck';
    case '3.3':
      return 'mus_chest';
    case '3.4.1':
      return 'mus_abdomen';
    case '3.5':
      return 'mus_back';
    case '3.6.1':
      return 'mus_upper_cingulum';
    case '3.6.2':
      return 'mus_brachium';
    case '3.6.3':
      return 'mus_anterbrachium';
    case '3.6.4':
      return 'mus_manus';
    case '3.7.1':
      return 'mus_lower_cingulum';
    case '3.7.2':
      return 'mus_femur';
    case '3.7.3':
      return 'mus_crus';
    case '3.7.4':
      return 'mus_pedis';
    case '4.1.2':
      return 'org_upper_digestive';
    case '4.1.4':
      return 'org_upper_digestive';
    case '4.1.5':
      return 'org_upper_digestive';
    case '4.1.6':
      return 'org_esophagus';
    case '4.1.7':
      return 'org_gaster';
    case '4.1.8':
      return 'org_whole_intestine';
    case '4.1.9':
      return 'org_whole_intestine';
    case '4.1.10':
      return 'org_rectum';
    case '4.1.12':
      return 'org_liver';
    case '4.1.13':
      return 'org_gallbladder_bile_ducts_pancreas';
    case '4.1.14':
      return 'org_gallbladder_bile_ducts_pancreas';
    case '4.2.2':
      return 'org_larynx';
    case '4.2.5':
      return 'org_pulmo';
    case '4.3.1':
      return 'org_urinary_system';
    case '4.3.2':
      return 'org_urinary_system';
    case '4.3.3':
      return 'org_urinary_system';
    case '4.4.1':
      return 'org_male_genital';
    case '4.4.2':
      return 'org_male_genital';
    case '4.4.3':
      return 'org_male_genital';
    case '4.4.4':
      return 'org_male_genital';
    case '4.4.5':
      return 'org_male_genital';
    case '4.5.1':
      return 'org_female_genital';
    case '4.5.2':
      return 'org_female_genital';
    case '4.5.4':
      return 'org_female_genital';
    case '4.5.5':
      return 'org_female_genital';
    case '4.5.6':
      return 'org_female_genital';
    case '4.5.7':
      return 'org_female_genital';
    default:
      return 'cns';
  }
};
